export const SET_IDENTITY = 'SET_IDENTITY_COLLECT'
export const SET_LINK_INFO = 'SET_LINK_INFO_COLLECT'
export const SET_COLLECT_DATA_STEP = 'SET_COLLECT_DATA_STEP'
export const SET_RECORDED_STATUS = 'SET_RECORDED_STATUS_COLLECT'
export const SET_SPIN_AGAIN_NUMBER = 'SET_SPIN_AGAIN_NUMBER_COLLECT'
export const SET_NOT_AVAILABLE_INDEX = 'SET_NOT_AVAILABLE_INDEX_COLLECT'
export const SET_COLLECT_MODE_ACTIVE = 'SET_COLLECT_MODE_ACTIVE'
export const SET_GROUP_OCCUPY_STATUS = 'SET_GROUP_OCCUPY_STATUS_COLLECT'
